import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";

import { openDocument } from "shared/actions/caseDetailActions";
import { useLISFinalizedDiagnosis } from "shared/hooks/useDiagnosis";
import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import LinkButton from "components/LinkButton";

import Sidebar from "../Sidebar";

const WPLAddonMessageDialog = ({
  caseDetail,
}: {
  caseDetail: CaseDetailState;
}) => {
  const dispatch = useDispatch();

  const finalDiagnosis = useLISFinalizedDiagnosis(caseDetail);

  const isAmended = caseDetail.case_addon?.find(
    (addon) => addon.addon_type === "amend"
  );
  const isAddended = caseDetail.case_addon?.find(
    (addon) => addon.addon_type === "addend"
  );

  return (
    <Sidebar
      isWide
      hat={
        <div className="FinalizedDiagnosis__header">
          <span>
            {caseDetail.accession} has been{" "}
            {isAmended
              ? isAddended
                ? "amended and addended"
                : "amended"
              : "addended"}
          </span>
        </div>
      }
    >
      <div className="Sidebar__contentContainer">
        {finalDiagnosis?.finalized_report_id && (
          <span>
            View the{" "}
            <LinkButton
              title="Download Report"
              className="Button Button--transparent"
              onClick={() => {
                caseDetail.id &&
                  finalDiagnosis?.finalized_report_id &&
                  dispatch(
                    openDocument(
                      caseDetail.id,
                      finalDiagnosis.finalized_report_id
                    )
                  );
              }}
            >
              Final Report &nbsp; <FontAwesomeIcon icon="file-download" />
            </LinkButton>{" "}
            for the full diagnosis
          </span>
        )}
      </div>
    </Sidebar>
  );
};

export default WPLAddonMessageDialog;
